// Module-scoped read-side mirror of the rule cache the saga
// maintains. Lives outside sagas.ts so non-saga code (selectors)
// can read the latest rule set without a Redux dispatch round
// trip.
//
// Updated by sagas.ts via captureRulesRef. Read-only externally.

import type { ElkaRule, RuleSet } from './sync';

let latest: RuleSet = new Map<string, ElkaRule>();

/** Returns the latest synced rule set. Empty until /sync/pull lands. */
export function latestRules(): RuleSet {
  return latest;
}

/** sagas.ts calls this on every PREDICATE_RULES_LOADED action. */
export function setLatestRules(next: RuleSet): void {
  latest = next;
}
